import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchFacetRefinementSelect } from '@uncinc/react-searchkit';

import { facetAttributes } from '../config';

export interface SearchOcularDBAdvancedFacetsProps {
  className?: string;
}

const SearchOcularDBAdvancedFacets: React.FC<SearchOcularDBAdvancedFacetsProps> = (props) => {
  const { className } = props;

  const { t } = useTranslation();

  const classNames = c('SearchOcularDB__AdvancedFacets', className);

  return (
    <div className={classNames}>
      <h2 className="asH3 mb-6">
        {t('components.search_general.facets.advanced_filters_title')}
      </h2>

      <div className="SearchOcularDB__AdvancedFacets__facets">
        {facetAttributes.map((facetAttribute) => {
          const attribute = typeof facetAttribute === 'object' ? facetAttribute.attribute : facetAttribute;

          return (
            <SearchFacetRefinementSelect
              key={attribute}
              attribute={attribute}
              // @ts-ignore @TODO RSK: Fix restProps typing
              title={t(`components.search_oculardb.facets.${attribute}.title`)}
              placeholder={t(`components.search_oculardb.facets.${attribute}.placeholder`)}
              searchable
            />
          );
        })}
      </div>
    </div>
  );
};

export default SearchOcularDBAdvancedFacets;
